import React from 'react';
import { PromoEnrollView } from './container';

export const PromoEnrollScreen= ({ navigation }: { navigation: any }) => {
    return <PromoEnrollView />
}